import { lazy } from "react"
import type { FC, LazyExoticComponent } from "react"

const LazySidebarEntity: LazyExoticComponent<FC> = lazy((): Promise<{ default: FC }> => import("./sidebar.entity"))

export { LazySidebarEntity }
